<section
  class="container-wrapper"
  [ngClass]="'container-wrapper-theme-' + className()"
  [class.is-ltr]="!appTranslate.isRTL()"
>
  <mat-label class="label" [class.required]="!hideRequiredMarker() && inputControl().hasValidator(Validators.required)">{{
    label() || '' | translate
  }}
    @if (infoTooltip()) {
      <mat-icon class="help-icon" svgIcon="icon_info_24" [appTooltip]="infoTooltip() | translate" [position]="TooltipPosition.BELOW" />
    }
  </mat-label>
  <mat-form-field class="container" appearance="outline" subscriptSizing="dynamic" [class.readonly]="readonly()">
    <input
      matInput
      [readonly]="readonly()"
      [type]="inputType()"
      [formControl]="inputControl()"
      [placeholder]="placeholder() || '' | translate"
      (blur)="blurEvent.emit()"
    />

    @let firstError = getFirstError();
    @if (firstError) {
      <mat-error class="error-active">
        {{ firstError.message | translate }}
      </mat-error>
    }@else if(hintMessage()) {
      <mat-hint class="field-hint">
        {{ hintMessage() | translate }}
      </mat-hint>
    }
  </mat-form-field>
  @if (buttonConfig()) {
    <button type="button" [ngClass]="buttonConfig()?.className" [disabled]="buttonConfig()?.disabled" (click)="btnClickEmitter.emit()">
      <span>{{ buttonConfig()?.text || '' | translate }}</span>
    </button>
  }
</section>
